/**
 * used to transform savedCardDTO object.
 *
 * @param savedCardDTO
 * @returns {{customerId: number,
 *            expiryMonth: number,
 *            expiryYear: number,
 *            issuer: string,
 *            maskedCardNumber: string,
 *            mode: string,
 *            name: string,
 *            paymentGateway: string,
 *            token: string,
 *            type: string,
 *            offerKeys: []}}
 *
 * [ used primarily in ./savedCardDTOListTransformer.js ]
 */

interface ISavedCardDtoTransformer {
  offerKeys: [];
  customerId: number;
  last4: string;
  expiryMonth: number;
  expiryYear: number;
  mode: string;
  type: string;
  name: string;
  token: string;
  issuer: string;
  paymentGateway: string;
  tokenized: boolean;
  issuerBankIconUrl: string;
  cvvLessEligible: boolean;
  cvvLessMessage: string;
  logoUrl: string;
  networkTypeIconUrl: string;
}

export const savedCardDtoTransformer = (savedCardDTO: ISavedCardDtoTransformer) => ({
  customerId: savedCardDTO.customerId || -1,
  expiryMonth: savedCardDTO.expiryMonth || -1,
  expiryYear: savedCardDTO.expiryYear || -1,
  issuer: savedCardDTO.issuer || "",
  maskedCardNumber: savedCardDTO.last4 || "",
  mode: savedCardDTO.mode || "",
  name: savedCardDTO.name || "",
  paymentGateway: savedCardDTO.paymentGateway || "",
  token: savedCardDTO.token || "",
  type: savedCardDTO.type || "",
  offerKeys: savedCardDTO.offerKeys,
  issuerBankIconUrl: savedCardDTO?.issuerBankIconUrl || "",
  tokenized: savedCardDTO?.tokenized || false,
  cvvLessEligible: savedCardDTO?.cvvLessEligible || false,
  cvvLessMessage: savedCardDTO?.cvvLessMessage || "",
  logoUrl: savedCardDTO?.logoUrl,
  networkTypeIconUrl: savedCardDTO?.networkTypeIconUrl,
  last4: savedCardDTO?.last4
});
